module.exports = __webpack_public_path__ + "static/img/conversion-2.e654350.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/conversion-2.svg
// module id = 1425
// module chunks = 0